module.exports = __webpack_public_path__ + "img/momo_cta_button_available.35722be2.png";